import * as React from 'react';
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, Icon } from '@mui/material';
import { tokens } from '../theme/tokens';

export interface ConfirmationOptions {
  dialogId?: string;
  open?: boolean;
  title?: string;
  message?: string;
  alertSeverity?: 'success' | 'warning' | 'info';
  onSubmit?: () => void;
  onClose?: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationOptions> = ({
  dialogId,
  open,
  title,
  message,
  alertSeverity,
  onSubmit,
  onClose
}) => {
  return (
    <Dialog open={!!open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id={dialogId} sx={{ background: tokens.sidebar }}>
        {title}
      </DialogTitle>

      {/* v9 drops the content's top padding after a title and adds 20px below; v4 had 8px on both. */}
      <DialogContent sx={{ px: 0, py: 1, '.MuiDialogTitle-root + &': { pt: 1 } }}>
        <Alert severity={alertSeverity}>{message}</Alert>
      </DialogContent>

      <DialogActions sx={{ background: tokens.sidebar }}>
        <Button variant="outlined" id="cancel-btn" startIcon={<Icon>{'close'}</Icon>} onClick={onClose} color="primary">
          {'Cancel'}
        </Button>
        <Button
          onClick={onSubmit}
          startIcon={<Icon>{'check'}</Icon>}
          id="confirm-btn"
          variant="contained"
          color="primary"
        >
          {'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
